<template>
    <div>
        <div class="card">
            <div class="card-header">
              <span v-if="!overTwoYears">
                Please enter all facilities where you have worked in the last 24 months.  If the facility is the one you currently work at, please include your
                starting date and the last working date for which you have received a paycheck.  Otherwise, please include your starting date and end date.
                If you have worked at a facility multiple times in this 24 month period, please enter the facility once for each work period.
              </span>
              <span v-else>
                Please enter all facilities where you have worked since {{getLastWorkedDateLong()}}.
                If the facility is the one you currently work at, please include your
                starting date and the last working date for which you have received a paycheck.  Otherwise, please include your starting date and end date.
                If you have worked at a facility multiple times in this time period, please enter the facility once for each work period.
              </span>
            </div>
            <div class="card-body">
              <div v-if="renewalApplication.expirationDate && overTwoYears">
                <div>You have a gap longer than 2 years since the employment provided on your previous renewal application or your test out, whichever is later.<br/>
                  Depending on your specific work history, you might need to provide W-2(s), first paystub, most recent paystub, or any combination thereof.</div>
                <div v-if="gaps.length>0">
                  <div class="font-weight-bold">Uncovered period{{gaps.length>1?'s':''}}:</div>
                    <ul>
                      <li v-for="(gap, index) in gaps" :key="index">{{gap.start}} - {{gap.end}}</li>
                    </ul>
                  <div class="alert alert-danger">If you have a gap over 24 months in nurse aide work history, you must retest and pass both the knowledge and skills test to become Active on the Minnesota Nurse Aide Registry.</div>
                </div>
                <div class="alert alert-info">We recommend filling out the employment history fully prior to attaching any documents as documents requested per employer may change depending on your specific work history.</div>
              </div>
              <br/><br/>
              <div v-for="(emp, index) in employers" :key="emp.id">
                    <div v-if="index > 0">
                      <br/>
                      <hr/>
                      <br/>
                    </div>
                <h3>Employer {{index+1}} of {{employers.length}}</h3>
                    <b-row v-if="index === 0">
                        <b-col>
                            <BaseCheckboxInput :label="overTwoYears?`This facility is my current workplace and only workplace since ${getLastWorkedDateLong()}.`:'This facility is my current workplace and only workplace in the last 24 months'"
                                               v-model="opts.only"
                                               :v="$v.only"
                                               slug="only"
                                               :setId="'only' + index"
                                               v-on:change="resetOnly()"

                            />
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <BaseCheckboxInput label="I am working at this facility through a staffing agency."
                                               v-model="emp.staffingAgency"
                                               :v="$v.employers.$each[index].staffingAgency"
                                               slug="staffingAgency"
                                               :setId="'staffingAgency' + index"
                            />
                        </b-col>
                    </b-row>
                  <b-row>
                    <b-col>
                      <BaseRadioInput
                          v-model="emp.inState"
                          label="This facility is in Minnesota"
                          :v="$v.employers.$each[index].inState"
                          :options="opts.yesNoBoolOptions"
                          @input="handleInstateInput(emp, $event)"
                      />
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <BaseSelector v-model="emp.facilityType"
                                    :v="$v.employers.$each[index].facilityType"
                                    slug="facType"
                                    label="Facility Type"
                                    :setId="'facType'+index"
                                    :options="opts.facilityTypeOptions"
                      />
                    </b-col>
                  </b-row>
                    <b-row>
                        <b-col>
                            <BaseTextInput v-model="emp.name"
                                           :v="$v.employers.$each[index].name"
                                           slug="employerName"
                                           label="Facility Name"
                                           :setId="'name'+index"
                            />
                        </b-col>
                    </b-row>
                  <b-row v-if="emp.searchResults">
                    <b-col cols="12">
                      <b-table hover small show-empty class="sr-caption" style="width: 100%"
                               aria-live="polite"
                               responsive="true"
                               :fields="employerSearchFields"
                               :items="emp.searchResults"
                               caption="Facility search table. To sort the data in this table by a specific column, go to the appropriate column header cell and use enter to sort the data ascending. Use enter again to sort descending.">
                        <tempate v-slot:no-data>
                          No Nursing Homes or Boarding Care Homes matching this name found.
                        </tempate>
                        <template v-slot:cell(actions)="row">
                          <b-button variant="primary" @click="selectFacility(row, emp)">Select</b-button>
                        </template>
                      </b-table>
                    </b-col>
                  </b-row>
                  <b-row>
                        <b-col cols="12">
                            <BaseTextInput v-model="emp.department"
                                           :v="$v.employers.$each[index].department"
                                           slug="employerDept"
                                           label="Department"
                                           :setId="'department'+index"
                                           v-if="!emp.inState || emp.hfid || !(emp.facilityType== null||emp.facilityType==='CBH'||emp.facilityType==='NH')"
                            />
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col>
                            <BaseTextInput v-model="emp.address.streetAddress"
                                           :v="$v.employers.$each[index].address.streetAddress"
                                           slug="streetAddress"
                                           label="Street Address"
                                           :setId="'streetAddress'+index"
                                           tip="Please include apartment number or PO Box number if relevant."

                            />
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="4">
                            <BaseTextInput v-model="emp.address.city"
                                           :v="$v.employers.$each[index].address.city"
                                           slug="city"
                                           label="City"
                                           :setId="'city'+index"

                            />
                        </b-col>
                        <b-col cols="4">
                            <BaseSelector v-model="emp.address.state"
                                          :v="$v.employers.$each[index].address.state"
                                          slug="state"
                                          label="State"
                                          :setId="'state'+index"
                                          :options="opts.stateOptions.filter(s=>emp.inState?s.value==='MN':s.value!=='MN')"

                            />
                        </b-col>
                        <b-col cols="4">
                            <BaseMaskedTextInput v-model="emp.address.postalCode"
                                           :v="$v.employers.$each[index].address.postalCode"
                                           slug="zip"
                                           label="Zip Code"
                                           :setId="'zip'+index"
                                                 mask="#####-####"

                            />
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="6">
                            <BaseDateOfBirthInput v-model="emp.startDate"
                                           :v="$v.employers.$each[index].startDate"
                                           slug="startDate"
                                           label="Start Date"
                                           :setId="'startDate'+index"
                                           :messages="opts.startDateMessages"
                                           tip="Format: MM/DD/YYYY"
                                           @input="calcEmploymentGaps"
                            />
                        </b-col>
                        <b-col cols="6">
                            <BaseDateOfBirthInput v-model="emp.endDate"
                                           :v="$v.employers.$each[index].endDate"
                                           slug="endDate"
                                           label="End Date"
                                           tip="If you are currently working at this location please leave the end date blank. Format: MM/DD/YYYY"
                                           :setId="'endDate'+index"
                                           :messages="opts.endDateMessages"
                                           @input="calcEmploymentGaps"
                            />
                            <b-button variant="secondary" @click="emp.endDate=null">
                                Clear End Date
                            </b-button>
                        </b-col>
                    </b-row>
                    <div v-if="overTwoYears">
                      <div v-if="needsFirstPaystub(emp)">
                        <span v-bind:class="[missingAttachment(index, 'PS', 'First')?'text-danger':'']">
                        <span class="font-weight-bold">Current attached first paystub: </span>
                        <span>{{getPaystub(index, 'First')}}</span></span>
                        <span class="green-required"></span>
                      </div>
                        <div v-if="missingAttachment(index, 'PS', 'First')" class="d-block invalid-feedback">First paystub is required.</div>
                      <div v-if="needsLastPaystub(emp)">
                        <span v-bind:class="[missingAttachment(index, 'PS', 'Last')?'text-danger':'']">
                        <span class="font-weight-bold">Current attached last paystub: </span>
                        <span>{{getPaystub(index, 'Last')}}</span></span>
                        <span class="green-required"></span>
                      </div>
                      <div v-if="missingAttachment(index, 'PS', 'Last')" class="d-block invalid-feedback">Last paystub is required.</div>
                      <div v-if="missingAttachment(index, 'PS', 'First')||missingAttachment(index,'PS','Last')" class="d-block invalid-feedback">Upload a copy of one or more paystubs, the paystub(s) must reflect at least 8 hours of regular pay as a Nurse Aide.</div>
                      </div>


                    <div v-else>
<!--                <div>-->
                        <div><span v-bind:class="[missingAttachment(index, 'PS')?'text-danger':'']">
                            <span class="font-weight-bold">Current attached paystub: </span>
                            <span>{{getPaystub(index)}}</span></span>
                            <span class="green-required"></span></div>
                        <div v-if="missingAttachment(index, 'PS')" class="d-block invalid-feedback">Paystub is required.</div>
                      <div v-if="missingAttachment(index, 'PS')" class="d-block invalid-feedback">Upload a copy of one or more paystubs, the paystub(s) must reflect at least 8 hours of regular pay as a Nurse Aide.</div>
                    </div>

                    <div v-if="emp.facilityType==='OTH'">
                        <div><span v-bind:class="[missingAttachment(index, 'JD')?'text-danger':'']">
                            <span class="font-weight-bold">Current attached job description: </span>
                            <span>{{getDescription(index)}}</span></span>
                            <span class="green-required"></span></div>
                        <div v-if="missingAttachment(index, 'JD')" class="d-block invalid-feedback">Job description is required.</div>
                    </div>
                    <div v-if="overTwoYears && emp.startDate">
                      <div v-for="n in calcNumberW2(emp)" v-bind:key="n">
                        <div>
                          <span v-bind:class="[missingW2(emp, calcW2Year(n, emp), index)?'text-danger':'']">
                          <span class="font-weight-bold">Current attached W-2 for year {{calcW2Year(n, emp)}}: </span>
                          <span>{{getFileNameForW2(emp, calcW2Year(n, emp))}}</span></span>
                          <span class="green-required"/>
                        </div>
                        <div v-if="missingW2(emp,calcW2Year(n,emp), index)" class="d-block invalid-feedback">W-2 is required.</div>
                      </div>
                    </div>

                    <FileAttachment v-on:attachment-added="addAttachment(index, $event)"
                                    v-on:attachment-failed="showRootToast('Error', 'Adding attachment failed','danger')"
                                    :attachment-type-options="trimAttachmentTypeOptions(emp)"
                                    describedBy="paystubs"
                                    :id="'paystub'+index"
                                    :startYear="getW2StartYear(emp)"
                                    :numYears="calcNumberW2(emp)"
                                    :needsFirstPaystub="needsFirstPaystub(emp)"
                                    :needsLastPaystub="needsLastPaystub(emp)"
                                    :overTwoYears="overTwoYears"
                    />


                    <button class="btn btn-primary mt-2" @click="removeEmployer(index)" v-if="index!==0">Remove Employer</button>
                </div>
                <button class="btn btn-primary mt-2" @click="addEmployer()" v-if="!isOnlyEmp()">Add Employer</button>
                <th/>
                <br/>
                <b-row class="mt-2">
                    <b-col>
                        Expiration Date Post Employment: {{formatDate(postEmploymentDate)}}
                    </b-col>
                </b-row>
            </div>
        </div>
      <b-row>
        <b-col>
          <b-button variant="secondary" class="m-2" @click="saveDraft">Save Draft</b-button>
          <p>You have 90 days to submit this application after saving it as a draft. After 90 days, drafts that are not submitted are deleted.</p>
        </b-col>
      </b-row>
    </div>
</template>

<script>

    import {commonOptions} from "@/mixins/commonOptions";
    import BaseTextInput from "@/components/templates/input/BaseTextInput";
    import BaseDateOfBirthInput from "@/components/templates/input/BaseDateOfBirthInput";
    import FileAttachment from "@/components/templates/input/FileAttachment";
    import { required, minLength } from 'vuelidate/lib/validators'
    import minDate from "@/validators/minDate";
    import maxDate from "@/validators/maxDate";
    import axios from 'axios'
    import axiosRetry from 'axios-retry'
    import {toastService} from "@/mixins/toastService";
    import moment from 'moment';
    import BaseMaskedTextInput from "@/components/templates/input/BaseMaskedTextInput";
    import BaseSelector from "@/components/templates/input/BaseSelector";
    import BaseCheckboxInput from "@/components/templates/input/BaseCheckboxInput";
    import BaseRadioInput from "../templates/input/BaseRadioInput.vue";

    axiosRetry(axios, { retries: 3,
        retryDelay: axiosRetry.exponentialDelay  });

    export default {
        name: 'employmentWizard',
        data() {
            return {
                overTwoYears: null,
                gaps: [],
                employerSearchFields:[
                  {key: "hfid", label: "HFID", sortable: true},
                  {key: "name", label: "Name", sortable: true},
                  {key: "address.streetAddress", label: "Address", sortable: true},
                  {key: "address.city", label: "City", sortable: true},
                  {key: "address.state", label: "State", sortable: true},
                  {key: "address.postalCode", label: "Zip", sortable: true},
                  {key: "actions", sortable: false}
                ],
                employers: [{
                    id: null,
                    name: null,
                    department: null,
                    address: {
                        streetAddress: null,
                        city: null,
                        postalCode: null,
                        state: null,
                    },
                    startDate: null,
                    endDate: null,
                    attachments: [],
                    staffingAgency: false,
                    facilityType: null,
                    inState: true,
                    searchResults: null
                }],
                opts: {
                    startDateMessages: {
                        minDate: 'Start Date must be after 01/01/1900.',
                        maxDate: 'Start Date cannot be in the future.'
                    },
                    endDateMessages: {
                        minDate: 'End Date must be after Start Date.',
                        maxDate: 'End Date can not be in the future.'
                    },
                    attachmentOptions: [],
                    only: false,
                    facilityTypeOptions: []
                },

            }
        },

    components: {
      BaseRadioInput,
        BaseTextInput,
        BaseDateOfBirthInput,
        FileAttachment,
        BaseMaskedTextInput,
        BaseSelector,
        BaseCheckboxInput
    },
    created() {
      this.loadTypeOptions();
      this.loadFacilityTypeOptions();
      // this.getConfirmedFacilities();
      setTimeout(()=>{
        if(this.renewalApplication.employers) {
          let tempEmployers = [];
          for(let i=0;i<this.renewalApplication.employers.length;i++){
            tempEmployers.push(this.renewalApplication.employers[i]);
          }
          this.$nextTick(()=>{
            this.employers = tempEmployers;
            this.$nextTick(()=>{
              this.renewalApplication.suppressFirstUpdates = false;
            })
          })
        }

        this.overTwoYears = this.checkTwoYearExpirationGap(this.renewalApplication.expirationDate);
        this.$nextTick(()=> {
          if (this.overTwoYears) {
            this.calcEmploymentGaps();
          }
        })
      }, 10000)
    },
    mixins: [
        commonOptions,
        toastService
    ],
    props: {
        renewalApplication: Object
    },
    validations(){
        return{
            employers: {
                required,
                minLength: minLength(1),
                $each: {
                    id: { required: false },
                    name: { required },
                    department: { required: false },
                    address: {
                        streetAddress: { required },
                        city: { required },
                        postalCode: { required },
                        state: { required },
                    },
                    startDate: { required,
                        minDate: minDate(new Date('1900-01-01')),
                        maxDate: maxDate(new Date())
                    },
                    endDate: { required: false,
                        maxDate: maxDate(new Date()),
                        minDate: minDate(">")
                    },
                    attachments: { required , minLength: minLength(1),
                                  correctAttachments: function(obj, parent){
                                    if(this.overTwoYears) {
                                      if (this.needsFirstPaystub(parent)) {
                                        if (!obj.find(a => a.type.code === 'PS' && a.otherType === 'First')) {
                                          return false;
                                        }
                                      }
                                      if (this.needsLastPaystub(parent)) {
                                        if (!obj.find(a => a.type.code === 'PS' && a.otherType === 'Last')) {
                                          return false;
                                        }
                                      }
                                      let w2StartYear = this.getW2StartYear(parent);
                                      let numW2 = this.calcNumberW2(parent);
                                      for (let i = 0; i < numW2; i++) {
                                        if (!obj.find(a => a.type.code === 'W2' && a.otherType.includes((w2StartYear + i) + ''))) {
                                          return false;
                                        }
                                      }
                                    }
                                    else{
                                      if(!obj.find(a=>a.type.code==='PS')){
                                        return false;
                                      }
                                    }
                                    if(parent.facilityType.code==='OTH'){
                                      if(!obj.find(a=>a.type.code==='JD')){
                                        return false;
                                      }
                                    }
                                    return true;
                                   },
                                  },
                    staffingAgency: {required: false },
                    facilityType: {required},
                    inState: {required},
                    hfid: {required: false}
                }
            },
            only: { required: false },
            form: ['employers']
        }
    },
    methods: {
      addEmployer: function () {
        if (!this.isOnlyEmp()) {
          this.employers.push({
            id: null,
            name: null,
            address: {
              streetAddress: null,
              city: null,
              state: null,
              postalCode: null,
            },
            startDate: null,
            endDate: null,
            attachments: [],
            inState: true,
            hfid: null,
            searchResults: null
          });
        }
      },
      missingW2(emp, year, index) {
        return this.$v.form.employers.$each[index].$dirty && this.$v.form.employers.$each[index].$invalid && emp.attachments.find(a => a.type.code === 'W2' && a.otherType.includes(year)) == null;
      },
      isOnlyEmp() {
        return this.opts.only
      },
      addAttachment(index, value) {
        if (value.type.code === 'W2') {
          let years = value.otherType.split(',');
          for (let i = 0; i < years.length; i++) {
            let previousW2ForYear = this.employers[index].attachments.find(a => a.type.code === 'W2' && a.otherType.includes(years[i]));
            if (previousW2ForYear) {
              let previousW2Years = previousW2ForYear.otherType.split(',').filter(y => y !== years[i]);
              if (previousW2Years.length === 0) {
                this.employers[index].attachments = this.employers[index].attachments.filter(w2 => w2 !== previousW2ForYear);
              } else {
                previousW2ForYear.otherType = previousW2Years.join(',');
              }
            }
          }
          this.employers[index].attachments.push(value);
        } else {
          var existing = this.employers[index].attachments.findIndex(a => a.type.code === value.type.code && (a.otherType === null || value.otherType === a.otherType))
          if (existing > -1) {
            this.employers[index].attachments[existing] = value
            this.employers.splice()
          } else {
            this.employers[index].attachments.push(value);
          }
        }
        this.showRootToast('Attachment added', 'Successfully added attachment', 'success');
      },
      removeEmployer: function (i) {
        this.$delete(this.employers, i);
      },
      resetOnly() {
        if (this.isOnlyEmp()) {
          this.employers = this.employers.slice(0, 1)
        }
      },
      validate() {
        let gapValidate = true;
        if (this.gaps.length > 0) {
          gapValidate = false;
        }
        this.$v.form.$touch();
        let isValid = !this.$v.form.$invalid;
        this.$emit('on-validate', this.$data, isValid);
        if (!gapValidate) {
          this.showRootToast("Gaps in history", "You have " + (this.gaps.length === 1 ? 'a gap' : 'gaps') + " over 24 months in nurse aide work history, you must provide additional employment, if you are unable to you must retest and pass both the knowledge and skills test to become Active on the Minnesota Nurse Aide Registry.", "danger")
        }
        return isValid && gapValidate;
      },
      loadTypeOptions() {
        axios.get(`${process.env.VUE_APP_API_BASE_URL}/attachments/public/employerTypes`, {ignoreHeader: true})
            .then(response => {
              for (let type of response.data) {
                this.opts.attachmentOptions.push({
                  value: type.code,
                  text: type.description
                })
              }
            });
      },
      loadFacilityTypeOptions() {
        axios.get(`${process.env.VUE_APP_API_BASE_URL}/application/facilityTypes`, {ignoreHeader: true})
            .then(response => {
              for (let type of response.data) {
                this.opts.facilityTypeOptions.push({
                  value: type.code,
                  text: type.description
                })
              }
            })
      },

      trimAttachmentTypeOptions(employer) {
        let options = [];
        for (let i = 0; i < this.opts.attachmentOptions.length; i++) {
          options.push(this.opts.attachmentOptions[i]);
        }
        if (employer.facilityType !== "OTH") {
          options = options.filter(a => a.value !== "JD");
        }
        if (!this.overTwoYears) {
          options = options.filter(a => a.value !== "W2");
        } else {
          if (this.calcNumberW2(employer) === 0) {
            options = options.filter(a => a.value !== "W2");
          }
          if (!this.needsFirstPaystub(employer) && !this.needsLastPaystub(employer)) {
            options = options.filter(a => a.value !== "PS");
          }
        }
        return options;
      },
      showRootToast(title, message, type) {
        this.$root.$bvToast.toast(message, {
          title: title,
          toaster: 'b-toaster-top-center',
          solid: true,
          variant: type,
          appendToast: true,
          noAutoHide: true
        })
        this.toastFocus()
      },
      toastFocus() {
        setTimeout(() => {
          let elem = document.getElementsByClassName("toast")
          elem = elem[elem.length - 1]
          elem.focus()
        }, 100)
      },
      handleInstateInput(emp, event) {
        if(!this.renewalApplication.suppressFirstUpdates) {
          if (event) {
            emp.id = null;
            emp.name = null;
            emp.address.streetAddress = null;
            emp.address.city = null;
            emp.address.state = "MN";
            emp.address.postalCode = null;
            emp.startDate = null;
            emp.endDate = null;
            emp.hfid = null;
          } else {
            emp.id = null;
            emp.name = null;
            emp.address.streetAddress = null;
            emp.address.city = null;
            emp.address.state = null;
            emp.address.postalCode = null;
            emp.startDate = null;
            emp.endDate = null;
            emp.hfid = null;
          }
        }
      },
      findFacilityByName(emp) {
        axios.post(`${process.env.VUE_APP_API_BASE_URL}/application/facility/find`, emp.name)
            .then(response => {
              emp.searchResults = response.data;
            })
            .catch(error => {
              this.showRootToast("Not found", "Unable to find a nursing home or boarding care facility matching this HFID", "danger")
            })
      },
      // getConfirmedFacilities() {
      //   axios.get(`${process.env.VUE_APP_API_BASE_URL}/application/facility/getConfirmed`)
      //       .then(response => {
      //         if (response.data.length > 0) {
      //           let temp = [];
      //           for (let i = 0; i < response.data.length; i++) {
      //             temp.push({
      //               id: null,
      //               name: response.data[i].name,
      //               facilityType: response.data[i].facilityType.code,
      //               hfid: response.data[i].hfid,
      //               address: {
      //                 streetAddress: response.data[i].address.streetAddress,
      //                 city: response.data[i].address.city,
      //                 state: response.data[i].address.state,
      //                 postalCode: response.data[i].address.postalCode,
      //               },
      //               startDate: null,
      //               endDate: response.data[i].endDate,
      //               attachments: [],
      //               inState: response.data[i].address.state === 'MN',
      //               lock: true,
      //             })
      //             this.employers = temp;
      //           }
      //         }
      //       })
      // },

        missingAttachment(index, attachmentType, firstOrLast){
            if(firstOrLast){
              return ((this.needsFirstPaystub(this.employers[index]) &&firstOrLast==='First') || (this.needsLastPaystub(this.employers[index]) &&firstOrLast === 'Last')) && this.$v.form.employers.$each[index].$dirty && this.$v.form.employers.$each[index].$invalid && this.employers[index].attachments.find(a=>a.type.code===attachmentType && a.otherType===firstOrLast)==null
            }
            return this.$v.form.employers.$each[index].$dirty && this.$v.form.employers.$each[index].$invalid && this.employers[index].attachments.find(a=>a.type.code===attachmentType)==null
        },

        getPaystub(index, firstOrLast) {
            let filtered = null;
            if(firstOrLast){
              filtered = this.employers && this.employers[index] ? this.employers[index].attachments.filter(a=>a.type.code === 'PS' && a.otherType===firstOrLast) : null;
            }
            else {
              filtered = this.employers && this.employers[index] ? this.employers[index].attachments.filter(a => a.type.code === 'PS') : null;
            }
            return filtered != null && filtered.length > 0 ? filtered[0].filename : 'No paystub attached'
        },
        getDescription(index) {
            let filtered = this.employers && this.employers[index] ? this.employers[index].attachments.filter(a => a.type.code === 'JD') : null
            return filtered != null && filtered.length > 0 ? filtered[0].filename : 'No job description attached'
        },
        formatDate(unformattedDate){
            let formattedDate = moment(unformattedDate);
            if(!formattedDate.isValid()) return 'N/A';
            return formattedDate.format("MM/DD/YYYY")
        },

      selectFacility(row, emp) {
        emp.name = row.item.name;
        emp.address.streetAddress = row.item.address.streetAddress;
        emp.address.city = row.item.address.city;
        emp.address.state = row.item.address.state;
        emp.address.postalCode = row.item.address.postalCode;
        emp.hfid = row.item.hfid;
        emp.providerType = row.item.providerType;
        emp.searchResults = null;
      },
      checkTwoYearExpirationGap(expirationDate) {
        let lastWorkedDateFromPreviousApplication = moment(expirationDate).subtract(2, 'y');
        let today = moment();
        let yrDifference = today.diff(lastWorkedDateFromPreviousApplication, 'y', true);
        return yrDifference > 2;
      },
      calcNumberW2(employer) {
        let lastWorkedDateFromPreviousApplication = moment(this.renewalApplication.expirationDate).subtract(2, 'y');
        let employerStartDate = moment(employer.startDate);
        let employerEndDate = employer.endDate ? moment(employer.endDate) : moment();

        let result = (employerEndDate.year() - (employerStartDate.isAfter(lastWorkedDateFromPreviousApplication) ? employerStartDate.year() : lastWorkedDateFromPreviousApplication.year()) + 1);
        if (this.needsLastPaystub(employer)) {
          result--;
        }
        if (this.needsFirstPaystub(employer)) {
          result--;
        }
        return this.turnNegativeValueToZero(result);
      },
      calcW2Year(n, employer) {
        let employerStartDate = moment(employer.startDate);
        let lastWorkedDateFromPreviousApplication = moment(this.renewalApplication.expirationDate).subtract(2, 'y');
        let result = (n + (employerStartDate.isAfter(lastWorkedDateFromPreviousApplication) ? employerStartDate.year() : lastWorkedDateFromPreviousApplication.year()) - 1);
        if (this.needsFirstPaystub(employer)) {
          result++;
        }
        return result;
      },
      getW2StartYear(employer) {
        if (!employer.startDate) {
          return null;
        }
        let employerStartDate = moment(employer.startDate);
        let lastWorkedDateFromPreviousApplication = moment(this.renewalApplication.expirationDate).subtract(2, 'y');
        let result = (employerStartDate.isAfter(lastWorkedDateFromPreviousApplication) ? employerStartDate.year() : lastWorkedDateFromPreviousApplication.year());
        if (this.needsFirstPaystub(employer)) {
          result++;
        }
        return result;
      },
      getFileNameForW2(emp, year) {
        let w2 = emp.attachments.find(a => a.type.code === 'W2' && a.otherType.includes('' + year));
        if (w2) {
          return w2.filename;
        }
        return "No W-2 attached"
      },
      turnNegativeValueToZero(n) {
        return n < 0 ? 0 : n;
      },
      calcEmploymentGaps() {
        let gaps = [];
        let employersWithStartDates = this.employers.filter(e => e.startDate != null);
        let lastWorkedDateFromPreviousApplication = moment(this.renewalApplication.expirationDate).subtract(2, 'y');
        let daysNotWorked = Array(moment().diff(lastWorkedDateFromPreviousApplication, 'd') + 1).fill(true);
        for (let i = 0; i < employersWithStartDates.length; i++) {
          let startIndex = this.turnNegativeValueToZero(moment(employersWithStartDates[i].startDate).diff(lastWorkedDateFromPreviousApplication, 'd'));
          let endIndex;
          if (employersWithStartDates[i].endDate == null) {
            endIndex = moment().diff(lastWorkedDateFromPreviousApplication, 'd')
          } else {
            endIndex = moment(employersWithStartDates[i].endDate).diff(lastWorkedDateFromPreviousApplication, 'd');
          }
          daysNotWorked.fill(false, startIndex, endIndex + 1);
        }
        let i = 0;
        while (i < daysNotWorked.length) {
          if (daysNotWorked[i]) {
            let j = i + 1;
            while (daysNotWorked[j]) {
              j++;
            }
            let gapStart = moment(this.renewalApplication.expirationDate).subtract(2, 'y').add(i, 'd');
            let gapEnd = moment(this.renewalApplication.expirationDate).subtract(2, 'y').add(j - 1, 'd');
            if (gapEnd.diff(gapStart, 'y', true) >= 2) {
              gaps.push({
                start: gapStart.format("MM/DD/yyyy"),
                end: gapEnd.format("MM/DD/yyyy")
              })
            }
            i = j;
          } else {
            i++;
          }
        }
        this.gaps = gaps;
      },
      needsFirstPaystub(emp) {
        if (!this.overTwoYears) {
          return false;
        }
        let dateStarted = moment(emp.startDate);
        let yearStarted = dateStarted.year();
        let earliestEmployerStartingSameYear = this.employers.filter(e => e !== emp && moment(e.startDate).year() === yearStarted && dateStarted.isAfter(moment(e.startDate)));
        if (earliestEmployerStartingSameYear.length > 0) {
          return false;
        }
        let previousLastWorkedYear = moment(this.renewalApplication.expirationDate).subtract(2, 'y').year();
        if (yearStarted - previousLastWorkedYear < 2) {
          return false;
        }
        let previousYear = yearStarted - 1;
        let employersForPreviousYear = this.employers.filter(e => e.endDate != null && previousYear <= moment(e.endDate).year() && previousYear >= moment(e.startDate).year());
        if (employersForPreviousYear.length > 0) {
          return false;
        }
        previousYear--;
        employersForPreviousYear = this.employers.filter(e => e.endDate != null && previousYear <= moment(e.endDate).year() && previousYear >= moment(e.startDate).year());
        return employersForPreviousYear.length > 0 || previousYear === previousLastWorkedYear;

      },
      needsLastPaystub(emp) {
        if (!this.overTwoYears) {
          return false;
        }
        if (emp.endDate == null) {
          return true;
        }

        let yearEnded = moment(emp.endDate).year();
        let currentYear = moment().year();
        if (yearEnded === currentYear) {
          return true;
        }
        if (currentYear - yearEnded < 2) {
          return false;
        }
        let nextYear = yearEnded + 1;
        let employersForNextYear = this.employers.filter(e => e !== emp && nextYear >= moment(e.startDate).year() && (e.endDate == null || nextYear <= moment(e.endDate).year()));
        if (employersForNextYear.length > 0) {
          return false;
        }
        nextYear++;
        employersForNextYear = this.employers.filter(e => nextYear >= moment(e.startDate).year() && (e.endDate == null || nextYear <= moment(e.endDate).year()));
        return employersForNextYear.length > 0 || nextYear === currentYear;
      },
      getLastWorkedDateLong() {
        return moment(this.renewalApplication.expirationDate).subtract(2, 'y').format("MMMM D, yyyy")
      },
      saveDraft() {
        axiosRetry(axios, {retries: 0});
        let applicationTemp = Object.assign({}, this.renewalApplication);
        applicationTemp.employers = this.employers;
        let attachmentsTemp = [];
        for (let employerIndex = 0; employerIndex < this.employers.length; employerIndex++) {
          for (let attachmentIndex = 0; attachmentIndex < this.employers[employerIndex].attachments.length; attachmentIndex++) {
            attachmentsTemp.push(applicationTemp.employers[employerIndex].attachments[attachmentIndex]);
          }
        }
        axios.post(`${process.env.VUE_APP_API_BASE_URL}/application/draft`, {
          application: JSON.stringify(applicationTemp),
          attachments: attachmentsTemp
        })
            .then(response => {
              this.showRootToast('Draft Saved', 'Your draft has been saved and will be kept for 90 days', 'success')
            })
            .catch(error => {
              this.showRootToast('Draft Save Failed', 'Your has draft has failed to save', 'danger')
            })
      },
    },
    computed: {
        postEmploymentDate() {
          let nonNull = this.employers.filter(e => e.endDate != null)
          var formatted = 'N/A'
          if (nonNull.length > 0) {
            let date = new Date(Math.max.apply(null, nonNull.map(e => {
              return new Date(e.endDate);
            })));
            let mDate = moment(date).add(2, "years").add(1, "days")
            formatted = mDate.format("YYYY-MM-DD")
          }
          return formatted
        },
    },
}
</script>